import { render, staticRenderFns } from "./DataSyncHistory.vue?vue&type=template&id=4f7a941b&scoped=true"
import script from "./DataSyncHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataSyncHistory.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DataSyncHistory.vue?vue&type=style&index=0&id=4f7a941b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7a941b",
  null
  
)

export default component.exports